import { motion } from 'framer-motion';
import { Clock, MapPin, Navigation } from 'lucide-react';
import { CONTACT } from '../data/site';

export default function Location() {
  return (
    <section
      id="como-chegar"
      className="bg-[#101013] py-24 sm:py-32"
      data-testid="como-chegar-section"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:items-center lg:px-8">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6 }}
            className="font-mono-alt text-xs font-semibold uppercase tracking-[0.3em] text-[#FFB800]"
          >
            Como chegar
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-4 font-display text-5xl uppercase leading-none text-white sm:text-6xl"
          >
            Perto de você, quentinho e com amor
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="font-serif-accent mt-4 text-xl text-zinc-400"
          >
            Venha viver a experiência ao vivo ou retire seu pedido na loja.
          </motion.p>

          <div className="mt-10 space-y-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6 }}
              className="flex items-start gap-4 rounded-2xl border border-white/10 bg-[#141418] p-5"
              data-testid="como-chegar-address-card"
            >
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#FF5500]/15 text-[#FF5500]">
                <MapPin size={20} />
              </span>
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
                  Endereço
                </p>
                <p className="mt-1 text-white">{CONTACT.address}</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="flex items-start gap-4 rounded-2xl border border-white/10 bg-[#141418] p-5"
              data-testid="como-chegar-hours-card"
            >
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#FFB800]/15 text-[#FFB800]">
                <Clock size={20} />
              </span>
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
                  Horário de funcionamento
                </p>
                <p className="mt-1 text-white">{CONTACT.hours}</p>
                <p className="text-white">{CONTACT.hoursLate}</p>
                {CONTACT.closed && <p className="text-sm text-zinc-500">{CONTACT.closed}</p>}
              </div>
            </motion.div>
          </div>

          <motion.a
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
            href={CONTACT.mapsDirections}
            target="_blank"
            rel="noreferrer"
            data-testid="como-chegar-google-maps-btn"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FF5500] px-8 py-4 text-sm font-bold uppercase tracking-wider text-[#0D0D0F] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_36px_rgba(255,85,0,0.5)]"
          >
            <Navigation size={16} /> Traçar rota
          </motion.a>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8 }}
          className="map-dark overflow-hidden rounded-3xl border border-white/10"
        >
          <iframe
            data-testid="como-chegar-map-iframe"
            src={CONTACT.mapsEmbed}
            title="Mapa — Riths Burger"
            className="h-[380px] w-full lg:h-[520px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>
      </div>
    </section>
  );
}
